import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { AdaptedSelect, Optional, TextareaControl } from "../components/Form";
import { useMedicalConcernCategoriesQuery } from "../graphql";

export interface ICreateMedicalFormValues {
  id?: number;
  patientId: number;
  symptoms: string;
  diagnosis: string;
  recommendation: string;
  recipe: string;
  privateNote?: string;
  medicalConcernCategoryId: string;
}

interface IMedicalCardForm {
  onSubmit: (values: ICreateMedicalFormValues) => void;
  initialValues?: Optional<ICreateMedicalFormValues>;
}

export const MedicalCardForm: React.FC<IMedicalCardForm> = ({
  onSubmit,
  initialValues,
}) => {
  const { t } = useTranslation();
  const { data, loading } = useMedicalConcernCategoriesQuery();

  const validate = (values) => {
    const errors: { [key: string]: string } = {};

    if (!values.symptoms) {
      errors.symptoms = t("forms.requiredField");
    }

    if (!values.diagnosis) {
      errors.diagnosis = t("forms.requiredField");
    }

    if (!values.recommendation) {
      errors.recommendation = t("forms.requiredField");
    }

    if (!values.recipe) {
      errors.recipe = t("forms.requiredField");
    }

    if (!values.medicalConcernCategoryId) {
      errors.medicalConcernCategoryId = t("forms.requiredField");
    }

    return errors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({
        handleSubmit,
        form,
        errors,
        submitting,
        pristine,
        values,
      }) => (
        <Box as="form" p={2} onSubmit={handleSubmit}>
          <Field
            name="medicalConcernCategoryId"
            component={AdaptedSelect}
            label="Lista e simptomave"
            disabled={loading}
          >
            {data?.medicalConcernCategories?.map((item) => (
              <option value={item.id}>{item.name}</option>
            ))}
          </Field>

          <TextareaControl
            name="symptoms"
            label={t("patients.medicalCards.symtopms")}
          />
          <TextareaControl
            name="diagnosis"
            label={t("patients.medicalCards.diagnosis")}
          />
          <TextareaControl
            name="recommendation"
            label={t("patients.medicalCards.recommendations")}
          />
          <TextareaControl
            name="recipe"
            label={t("patients.medicalCards.recipe")}
          />

          <Box
            style={{
              background: "#dcbbbb",
              padding: "5px",
              marginBottom: "5px",
            }}
          >
            <TextareaControl
              name="privateNote"
              label={t("patients.medicalCards.privateNote")}
            />
          </Box>
          <ButtonGroup spacing={4}>
            <Button
              isLoading={submitting}
              loadingText={t("forms.submitting")}
              variantColor="teal"
              type="submit"
            >
              {t("forms.save")}
            </Button>
            <Button
              variantColor="teal"
              variant="outline"
              onClick={form.reset}
              isDisabled={submitting || pristine}
            >
              {t("forms.clear")}
            </Button>
          </ButtonGroup>
        </Box>
      )}
    />
  );
};
